"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnumStrings = void 0;

var getEnumStrings = function getEnumStrings(myEnum) {
  return Object.keys(myEnum).map(function (key) {
    return myEnum[key];
  }).filter(function (value) {
    return typeof value === 'string';
  });
};

exports.getEnumStrings = getEnumStrings;